import React from "react";
import uRLs from "../utils/baseUtils";
import { useAuth } from "../context/AuthProvider";
import DateConverter from "@heartinz/date_and_time_processor";

const SubscriptionModal = ({ isOpen, onClose, expiryDate }) => {
  const { isUser } = useAuth();
  if (!isOpen) return null;

  // Remove spaces, +, -, etc. for WhatsApp
  const phoneNumber = String(uRLs.CONTACT_PHONE || "").replace(/\D/g, "");

  return (
    <>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show"
        id="SubscriptionExpiredModal"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content subscription-ending-modal">
            {/* Header */}
            <div className="modal-header border-0">
              <div></div>

              {onClose && (
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={onClose}
                />
              )}
            </div>

            {/* Body */}
            <div className="modal-body text-center">
              {/* Warning Icon */}
              <div className="subscription-warning-icon">
                <i className="bx bx-error-alt" />
              </div>

              <h4 className="subscription-title">
                Your subscription is ending soon
              </h4>

              <p className="subscription-description">
                Your NegoBill subscription expires on{" "}
                <strong>
                  {DateConverter.ISOToDisplayFormat(
                    DateConverter.convertToTimeZone(
                      expiryDate,
                      isUser.timezone,
                    ),
                  ).date || "[EXPIRY DATE]"}
                </strong>
                . Renew before then to avoid any interruption to billing and
                sales.
              </p>

              {/* Contact Buttons */}
              <div className="subscription-actions">
                {/* Call */}
                <a
                  href={`tel:${uRLs.CONTACT_PHONE}`}
                  className="subscription-call-btn"
                >
                  <i className="bx bx-phone-call" />
                  <span>Call {uRLs.CONTACT_PHONE}</span>
                </a>

                {/* WhatsApp */}
                <a
                  href={`https://wa.me/${phoneNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="subscription-whatsapp-btn"
                >
                  <i className="bx bxl-whatsapp" />
                  <span>Contact on WhatsApp</span>
                </a>
              </div>

              <p className="subscription-note">
                If you're unable to reach us by phone, send us a message on
                WhatsApp instead — we'll get back to you shortly.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .subscription-ending-modal {
          border: 0;
          border-radius: 20px;
          overflow: hidden;
        }

        .subscription-ending-modal .modal-header {
          padding: 18px 24px 0;
        }

        .subscription-ending-modal .btn-close {
          opacity: 0.55;
          box-shadow: none;
        }

        .subscription-ending-modal .modal-body {
          padding: 0 42px 38px;
        }

        .subscription-warning-icon {
          width: 56px;
          height: 56px;
          margin: 0 auto 22px;
          border-radius: 14px;
          background: #fff6df;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .subscription-warning-icon i {
          font-size: 32px;
          color: #d99a16;
        }

        .subscription-title {
          margin-bottom: 12px;
          font-size: 21px;
          font-weight: 700;
          color: #151b2d;
        }

        .subscription-description {
          max-width: 460px;
          margin: 0 auto 26px;
          color: #6f7480;
          font-size: 13px;
          line-height: 1.7;
        }

        .subscription-description strong {
          color: #4c505b;
          font-weight: 600;
        }

        .subscription-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
        }

        .subscription-actions a {
          flex: 1;
          min-height: 42px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          text-decoration: none;
          font-size: 13px;
          font-weight: 600;
          transition: opacity 0.2s ease;
        }

        .subscription-actions a:hover {
          opacity: 0.9;
        }

        .subscription-actions i {
          font-size: 19px;
        }

        .subscription-call-btn {
          background: #292f78;
          color: #fff !important;
        }

        .subscription-whatsapp-btn {
          background: #25d366;
          color: #fff !important;
        }

        .subscription-note {
          max-width: 430px;
          margin: 16px auto 0;
          color: #8a8e98;
          font-size: 11px;
          line-height: 1.6;
        }

        @media (max-width: 576px) {
          .subscription-ending-modal .modal-body {
            padding: 0 22px 28px;
          }

          .subscription-actions {
            flex-direction: column;
          }

          .subscription-actions a {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default SubscriptionModal;
